export default {"src":"/_next/static/media/4-mouse-click.45e6c711.gif","height":480,"width":480};